/**
 * Align image containers to the same height based on the tallest image
 * Uses data-attributes for portability:
 * - data-image-align: on wrapper element to enable alignment
 * - data-image-container: on image container elements
 * - data-image-selector: on container elements (optional, defaults to 'img' within container)
 */
export function initImageAlignment() {
  // Find all sections that should have image alignment
  const imageAlignSections = document.querySelectorAll('[data-image-align]');
  if (imageAlignSections.length === 0) return;

  imageAlignSections.forEach(section => {
    // Find all image containers within this section
    const imageContainers = section.querySelectorAll('[data-image-container]');
    if (imageContainers.length === 0) return;

    // Find all images within the containers
    const images = Array.from(imageContainers).map(container => {
      // Check for data-image-selector attribute first, then fall back to img tag
      const imageSelector = container.getAttribute('data-image-selector') || 'img';
      return container.querySelector(imageSelector);
    }).filter(img => img !== null);

    if (images.length === 0) return;

    // Wait for images to load
    Promise.all(images.map(img => 
      img.complete ? Promise.resolve() : new Promise(resolve => {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      })
    )).then(() => {
      let maxHeight = 0;
      images.forEach(img => {
        const height = parseInt(img.getAttribute('height')) || img.naturalHeight || img.offsetHeight || 0;
        if (height > maxHeight) maxHeight = height;
      });
      
      // Apply height to all image containers
      if (maxHeight > 0) {
        imageContainers.forEach(container => {
          container.style.height = `${maxHeight}px`;
        });
      }
      
      return maxHeight;
    });
  });
}

